export const TicTacToeBoard = ({ state, mySymbol, currentTurn, onMove, gameOver }) => {
  const isMyTurn = currentTurn === mySymbol && !gameOver;
  
  const handleClick = (pos) => {
    if (!isMyTurn) return;
    if (state.board[pos] !== null) return;
    onMove(pos);
  };

  const isWinningCell = (pos) => {
    return state.winning_line && state.winning_line.includes(pos);
  };

  return (
    <div className="flex items-center justify-center p-8" data-testid="tic-tac-toe-board">
      <div>
        <div className="text-center mb-4">
          <p className="text-sm text-[#71717A]">
            You are: <span className="font-mono font-bold text-[#0047FF]">{mySymbol}</span>
          </p>
          {!gameOver && (
            <p className="text-sm font-medium mt-1">
              {isMyTurn ? (
                <span className="text-[#10B981]">Your turn</span>
              ) : (
                <span className="text-[#71717A]">Opponent&apos;s turn ({currentTurn})</span>
              )}
            </p>
          )}
        </div>
        
        <div className="grid grid-cols-3 gap-2 bg-[#09090B] p-2">
          {state.board.map((cell, i) => (
            <button
              key={i}
              onClick={() => handleClick(i)}
              disabled={!isMyTurn || cell !== null}
              className={`w-24 h-24 flex items-center justify-center text-5xl font-heading font-bold transition-all ${
                cell === null
                  ? isMyTurn
                    ? 'bg-white hover:bg-[#0047FF]/10 cursor-pointer'
                    : 'bg-white cursor-not-allowed'
                  : isWinningCell(i)
                    ? 'bg-[#10B981] text-white'
                    : cell === 'X'
                      ? 'bg-white text-[#0047FF]'
                      : 'bg-white text-[#EF4444]'
              }`}
              data-testid={`ttt-cell-${i}`}
            >
              {cell}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};
